import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const mechanicDetailApi = createApi({
  reducerPath: 'mechanicDetailApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['MechanicDetail', 'SkuList', 'StepList', 'AddStep', 'AddSku', 'DeleteSku', 'DeleteStep', 'ChangeStep'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
